import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";

// Self-hosted v2 fonts — Inter for body/display, JetBrains Mono for
// numerics. These CSS imports inline the @font-face rules via Vite so the
// fonts ship with the bundle instead of calling out to fonts.googleapis.com.
import "@fontsource/inter/400.css";
import "@fontsource/inter/500.css";
import "@fontsource/inter/600.css";
import "@fontsource/inter/700.css";
import "@fontsource/jetbrains-mono/400.css";
import "@fontsource/jetbrains-mono/500.css";

import "./styles/globals.css";
import { setTheme } from "@/lib/theme";
import { AppRoutes } from "@/routes";
import { ErrorBoundary } from "@/components/ErrorBoundary";
import { AuthProvider } from "@/lib/auth";
import { ToastProvider } from "@/components/ui/Toast";
import { TooltipProvider } from "@/components/ui/Tooltip";

// Pin the app to the light theme. Overwrites any stale `theme=dark`
// in localStorage so a previously-dark user lands on light on next load.
setTheme("light");

const rootElement = document.getElementById("root");
if (!rootElement) {
  throw new Error("Root element #root not found in index.html");
}

// ToastProvider is hoisted to the app root (outside <BrowserRouter>'s
// <AppRoutes>) so unauthenticated flows — Login in particular — can enqueue
// toasts without needing to re-mount the provider per route subtree.
// TooltipProvider hoisted here so any descendant `<Tooltip>` works without its
// own provider. `delayDuration={200}` matches the value WalletDetail used
// locally before Wave 1 consolidated tooltip chrome into a single primitive.
ReactDOM.createRoot(rootElement).render(
  <React.StrictMode>
    <TooltipProvider delayDuration={200}>
      <ToastProvider>
        <ErrorBoundary>
          <BrowserRouter>
            <AuthProvider>
              <AppRoutes />
            </AuthProvider>
          </BrowserRouter>
        </ErrorBoundary>
      </ToastProvider>
    </TooltipProvider>
  </React.StrictMode>,
);
